<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu 
                readOnly=""
            />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">{{ page_title }}</h3>
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <div class="">
                        <flash-message autoHide variant="success"></flash-message>
                        <b-navbar toggleable="lg" type="light" variant="light">
                            <b-navbar-brand href="#">Filter/Search</b-navbar-brand>
                            <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>
                            <b-collapse id="nav-collapse" is-nav>
                                <div class="search-wrapper col-12">
                                    <div class="row col-12 override-padding">
                                        <div class="search_filter_1">
                                            <b-form-select
                                                class="location-custom-select"
                                                name="status"
                                                id="status"
                                                v-model="search_status"
                                                :options="status"
                                                @change="changeStatus">
                                            </b-form-select>
                                        </div>
                                        <div class="search_filter_2">
                                            <b-form-select 
                                                class="location-custom-select" 
                                                v-model="search_group" 
                                                :options="account_groups_options"
                                                @change="changeGroups">
                                            </b-form-select>
                                        </div>
                                        <div class="search_filter_3">
                                            <b-form-select 
                                                class="location-custom-select" 
                                                v-model="perPage" 
                                                :options="pagination_options"
                                                @change="changePageLimit">
                                            </b-form-select>
                                        </div>
                                        <div class="search_filter_4">
                                            <input
                                                type="text"
                                                name="org name"
                                                id="user_fullname"
                                                class="search_org_text"
                                                ref="user_fullname"
                                                v-model="user_fullname"
                                                maxlength="250"
                                                :placeholder="'Search by ' + user_type_name"
                                                @keyup.enter="setUserFullNameFilter">
                                            <span class="search-icon" @click="setUserFullNameFilter">
                                                <i class="fa fa-search search_icons"></i>
                                            </span>
                                        </div>
                                        <div class="search_filter_5">
                                           <!-- <button type="button" @click="openAddNewUserToLocation" class="float-left btn btn-sm createBtn">Add New {{ user_type_name }} </button> -->
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-navbar>
                    </div>
                    <div class="margin-bottom-10"></div>
                    <div>
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                <div class="font-weight-bold">All {{ page_title }} ({{ usersCount }})</div>
                            </div>
                            <div class="list_locations">
                                <div class="row" v-if="userStatusUpdatedMsg">
                                    <div class="col-12 p-0">
                                        <div class="text-green">{{ userStatusUpdatedMsg }}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div
                                        class="location_header manage_heading_1"
                                        v-on:click="sortMethod('first_name')"
                                        >
                                        {{ user_type_name }} Name
                                        <i v-if="sortField == 'first_name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'first_name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_2"
                                        v-on:click="sortMethod('companyName')"
                                        >
                                        Location 
                                        <i v-if="sortField == 'companyName' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'companyName' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_3"
                                        v-on:click="sortMethod('group')"
                                        >
                                        Group
                                        <i v-if="sortField == 'group' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'group' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_4"
                                        v-on:click="sortMethod('email')"
                                        >
                                        Email
                                        <i v-if="sortField == 'email' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'email' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_5"
                                        v-on:click="sortMethod('phone_number')"
                                        >
                                        Phone Number
                                        <i v-if="sortField == 'phone_number' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'phone_number' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_6 text-center"
                                        >
                                        Active
                                    </div>
                                </div>
                                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div v-if="usersCount > 0" class="row_items">
                                    <div class="row_data_border" v-for="(item, index) in users" :key="index">
                                        <div class="location_item_1">
                                            <a @click="goToUserDetail(item.uid, item.accId)" class="ea-quick-link">{{ capitalizeFirstLetter(item.first_name,item.last_name) }}</a>
                                        </div>
                                        <div class="location_item_2">
                                            <a @click="openSidebar(item.accId)" class="ea-quick-link">{{ item.companyName }}</a>
                                        </div>
                                        <div class="location_item_3">
                                            <span v-if="item.groupName">{{ item.groupName }}</span>
                                            <span v-else>Ungrouped</span>
                                        </div>
                                        <div class="location_item_4">{{ item.email }}</div>
                                        <div class="location_item_5">
                                            <span v-if="item.phoneNumber">{{ item.phoneNumber }}</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                        <div class="location_item_6 text-center">
                                            <input 
                                                type="checkbox" 
                                                :name="'user_status_' + index"
                                                :id="'user_status_' + index"
                                                :ref="'user_status_' + index"
                                                :value="item.uid"
                                                :disabled="(item.userStatus != 'Active')"
                                                :checked="checkUserStatus(item.uid, item.userStatus)"
                                                @click="setUserActive(item, index, $event)">
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="text-red text-center m-4">{{ getNoRecordText(usersCount) }}</div>
                            </div>
                            <div class="col-12 float-left override-padding pagination-wrapper">
                                <EnterpriseAdminPagination v-if="totalPages"  
                                ref="eadmin_pagination"
                                :currentPage="currentPage"
                                :totalRows="rows"
                                :perPage="perPage"
                                :showPaginatedFunction="showUsersofPaginated"
                                :showPerPageFunction="perPagePaginated"
                                :totalPages="totalPages"
                                :sNo="sno"
                                >
                                </EnterpriseAdminPagination>
                            </div>
                        </b-card>
                    </div>
                    <div class="margin-bottom-10"></div>
                </div>
            </div>
        </div>

        <UserActivateModal 
            :isModalVisible="isUserActivateModal" 
            ref="user_activate_modal"
            page_from="users_menu"
            @close="closeUserActivateModal"
        />
        <UserInactivateModal
            :isModalVisible="isUserInactivateModal" 
            ref="user_inactivate_modal"
            page_from="users_menu"
            @close="closeUserInactivateModal"
        />

        <EnterpriseAdminOverlaySidebar
            :isModalVisible="isModalVisible" 
            @close="closeSidebar"
            ref="location_sidebar" 
            :readOnly="isReadOnly" 
        />

        <AddNewUserToLocation
            :isAddNewUserToLocationModalVisible="isAddNewUserToLocationModalVisible"
            ref="add_new_user_form_to_location"
            :user_type="user_type_name"
            :user_role="user_role"
            @close="closeAddNewUserToLocation"
        />

    </div>
</template>
<script>
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import EnterpriseAdminPagination from './enterprise_admin_pagination.vue';
import UserActivateModal from './user_activate_modal.vue';
import UserInactivateModal from './user_inactivate_modal.vue';
import AddNewUserToLocation from './add_new_user_to_location.vue';

export default {
    data() {
        return {
            loading: false,
            isModalVisible: false,
            isUserActivateModal: false,
            isUserInactivateModal: false,
            isAddNewUserToLocationModalVisible: false,
            page_title: 'Mentees',
            user_type_name: 'Mentee',
            user_role: 'ROLE_MENTEE',
            publicSortBy: 'ASC',
            sortField: 'first_name',
            searchParameters: {
              user_type: '',
              sort: {},
            },
            usersCount: 0,
            users: [],
            accountItems: [],
            search_status: '',
            status: [
                {text: 'All Status', value: ''},
                {text: 'Active', value: 'active'},
                {text: 'Inactive', value: 'Inactive'}
            ],
            pagination_options: [
                {text: 'Show 25', value: '25'},
                {text: 'Show 50', value: '50'},
                {text: 'Show 100', value: '100'},
                {text: 'Show 150', value: '150'},
                {text: 'Show 200', value: '200'}
            ],
            account_groups_options: [],
            search_group: '',
            user_fullname: '',
            search_status_name: '',
            search_group_name: '',
            statusSelected: [],
            pageOptions: [],
            rows: 0,
            perPage: 25,
            currentPage: 1,
            totalPages: 0,
            sno: 0,
            selectedIndex: '',
            userStatusUpdatedMsg: '',
        }
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        EnterpriseAdminOverlaySidebar,
        EnterpriseAdminPagination,
        UserActivateModal,
        UserInactivateModal,
        AddNewUserToLocation,
    },
    computed: {
        isReadOnly(){
            if (this.accountItems.enterprise_type === 'Readonly') {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        perPagePaginated() {
            this.currentPage = 1;
            this.$refs.eadmin_pagination.currentPageValue = 1;
            this.perPage = this.$refs.eadmin_pagination.perPageValue;
            this.fetchIUsersListitems();
        },
        showUsersofPaginated() {
            this.currentPage = this.$refs.eadmin_pagination.currentPageValue;
            this.fetchIUsersListitems();
        },
        changePageLimit() {
            this.currentPage = 1;
            this.$refs.eadmin_pagination.currentPageValue = 1;
            this.fetchIUsersListitems();
        },
        sortMethod(field) {
            this.sortField = field;
            if (this.publicSortBy == 'ASC') {
                this.publicSortBy = 'DESC';
            } else {
                this.publicSortBy = 'ASC';
            }
            this.fetchIUsersListitems();
        },
        changeStatus() {
            if (this.search_status) {
                var name = this.search_status.charAt(0).toUpperCase() + this.search_status.slice(1);
                this.search_status_name = name + ' ' + this.page_title;
            } else {
                this.search_status_name = this.defaultTitle;
            }
            this.fetchIUsersListitems();    
        },
        changeGroups() {
            if (this.search_group) {
                var name = this.showText(this.search_group);
                this.search_group_name = name + ' ' + this.page_title;
            }
            this.fetchIUsersListitems();    
        },
        setUserFullNameFilter() {
            this.fetchIUsersListitems();
        },
        fetchIUsersListitems() {
            this.loading = true;
            this.users = [];
            this.usersCount = 0;
            this.statusSelected = [];
            this.searchParameters.page = this.currentPage;
            this.searchParameters.perPage = this.perPage;
            this.searchParameters.sort.sortField = this.sortField;
            this.searchParameters.sort.sortBy = this.publicSortBy;
            this.searchParameters.user_type = this.page_title.toLowerCase();
            this.searchParameters.search_status = this.search_status;
            this.searchParameters.search_group = this.search_group;
            this.searchParameters.user_fullname = this.user_fullname;
            this.searchParameters.search_status_name = this.search_status_name;
            this.searchParameters.search_group_name = this.search_group_name;
            axios('/enterprise-admin/linked-accounts-users',
            {
                method: 'POST',
                data: {
                    'search_parameters': this.searchParameters
                }
            })
            .then(response => {
                this.loading = false;
                this.usersCount = response.data.users.length;
                this.users = response.data.users;
                this.statusSelected = response.data.activeUsers;
                this.currentPage = response.data.page;
                if(this.currentPage > 1) {
                  this.sno = this.perPage * (this.currentPage - 1);
                }
                else {
                  this.sno = 0;
                }
                this.rows = response.data.total_rows;
                this.totalPages = response.data.total_pages;
                this.clearFlashMessage();
            })
            .catch(() => {
            });
        },
        getEnterpriseGroups() {
            if (this.accountId > 0) {
                axios('/enterprise-admin/groups/' + this.accountId,
                {
                    method: 'GET',
                })
                .then(response => {
                    var groupsCount = response.data.groups.length;
                    this.account_groups_options.push({ text:'All Groups', value: '' });
                    for (var m = 0; m < groupsCount; m++) {
                        this.account_groups_options.push({ 
                            text: response.data.groups[m].text, 
                            value: response.data.groups[m].value 
                        });
                    }
                })
                .catch(() => {
                });
            }
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0 && this.accountId) {
                    return 'No ' + this.page_title + ' Found';
                }
            }
        },
        showText(val) {
            for (var i = 0; i < this.account_groups_options.length; i++) {
                if (this.account_groups_options[i].value != "" && this.account_groups_options[i].value === val){
                    this.selectedText = this.account_groups_options[i].text;
                    return this.selectedText.charAt(0).toUpperCase() + this.selectedText.slice(1);
                }
            }
            return '';
        },
        closeUserActivateModal() {
            this.isUserActivateModal = false;
            this.$refs['user_status_'+this.selectedIndex][0].checked = false;
        },
        closeUserInactivateModal() {
            this.isUserInactivateModal = false;
            this.$refs['user_status_'+this.selectedIndex][0].checked = true;
        },
        setUserActive(item, index, event) {
            var user = {
                first_name: item.first_name,
                last_name: item.last_name,
                id: item.uid,
                accountId: item.accId,
            }
            this.selectedIndex = index;
            if (event.target.checked) {
                this.isUserActivateModal = true;
                this.$refs.user_activate_modal.setUserInfo(user);
            } else {
                this.isUserInactivateModal = true;
                this.$refs.user_inactivate_modal.setUserInfo(user);
            }
        },
        capitalizeFirstLetter(fname, lname) {
            var userFullName = '';
            if (fname) {
                userFullName += fname.charAt(0).toUpperCase() + fname.slice(1) + ' ';
            } 
            if (lname) {
                userFullName += lname.charAt(0).toUpperCase() + lname.slice(1);
            }
            return userFullName;
        },
        openSidebar(accountId) {
            this.isModalVisible = true;
            this.$refs.location_sidebar.getLocationDetail(accountId);
        },
        closeSidebar() {
            this.isModalVisible = false;
            this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
        },
        goToUserDetail(userId, accountId) {
            this.isModalVisible = true;
            this.$refs.location_sidebar.editUserDetail(userId, accountId);
        },
        checkUserStatus(uid, status) {
            return (status == 'Active') ? 'checked' : '';
        },
        openAddNewUserToLocation() {
            this.isAddNewUserToLocationModalVisible = true;
            this.$refs.add_new_user_form_to_location.getLocations();
        },
        closeAddNewUserToLocation() {
            this.isAddNewUserToLocationModalVisible = false;
        },
        clearFlashMessage() {
            setTimeout(() => {
                this.userStatusUpdatedMsg = '';
            }, 2000);
        }
    },
    created() {
        setTimeout(() => {
            this.fetchIUsersListitems();
            
            axios('/enterprise-admin-info',
            {
                method: 'GET',
            })
            .then(resp => {
                this.accountItems = resp.data.account;
                this.accountId = this.accountItems.id;
                this.getEnterpriseGroups();
            })
            .catch(() => {
            });

        }, 1500);
    }
}
</script>
<style scoped>
.manage_locations { padding: 2rem; background-color: #FFF !important; }
.list_locations { padding: 0 1rem; margin: 1rem 0; }
.location_header { float: left; font-weight: 900; margin-top: 15px; }
.manage_heading_1 { width: 20%; cursor: pointer; }
.manage_heading_2 { width: 16%; cursor: pointer; }
.manage_heading_3 { width: 15%; cursor: pointer; }
.manage_heading_4 { width: 27%; cursor: pointer; }
.manage_heading_5 { width: 12%; cursor: pointer; }
.manage_heading_6 { width: 10%; }
.location_item_1 { width: 20%; float: left; }
.location_item_2 { width: 16%; float: left; }
.location_item_3 { width: 15%; float: left; }
.location_item_4 { width: 27%; float: left; }
.location_item_5 { width: 12%; float: left; }
.location_item_6 { width: 10%; float: left; }
.row_items { margin-right: -15px; margin-left: -15px }
.row_data_border { padding: 5px 0; margin: 10px 0; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.ea-group-name, .ea-quick-link {
  text-decoration: underline !important;
  cursor: pointer;
}
.heading { padding-left: 0px; }
.overview-icons { color: #bfbfbf; font-size: 1rem; }
.print_icons { font-size: 1.5rem;float: right; margin: 1px 0; color: #000 !important; }
.search_icons { font-size: 1.5rem; color: #bfbfbf; }
.location-custom-select { width: 150px; height: 32px; border-radius: 10px; }
.search_org_text { width: 80%;outline: 0; border-width: 0 0 2px; border-color: #bfbfbf; background-color: #e9e9e9; }
.license_text { text-decoration: underline; color: #00acee; }
.search_filter_1 { width: 16%; }
.search_filter_2 { width: 16%; }
.search_filter_3 { width: 34%; }
.search_filter_4 { width: 18%; }
.search_filter_5 { width: 16%; }
.createBtn, .createBtn:focus, .createBtn:active, .createBtn:hover {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 500;
  width: 100%;
  border-radius: 10px;
}
.loading_show { height: auto; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/account_mentees_list.vue